export const i18nConditionDeviationPage = {
  tabs: {
    ACTION_ISSUED: 'Open',
    COMPLETED: 'Closed',
    ALL: 'All',
  },
  newCd: 'New CD',
  action_status: {
    INVESTIGATING: 'Investigating',
    ACTION_ISSUED: 'Action Issued',
    COMPLETED: 'Completed',
    CANCELED: 'Canceled',
  },
  sap_note_status: {
    'open-critical': 'Open critical',
    'open-non-critical': 'Open non-critical',
    closed: 'Closed',
    offline: 'Not found',
    not_found: 'Not found',
    not_informed: 'Not informed',
  },
  columns: {
    id: 'ID',
    asset: 'Asset',
    dimension: 'Dimension',
    deviation_start: 'Dev. start',
    deviation_end: 'Dev. end',
    last_update_date: 'Last edit.',
    action_status: 'Action status',
    condition_evaluation: 'Sever.',
    diagnosis: 'Diagnosis',
    recommended_action: 'Recommended Action',
    sap_note: 'Note',
  },
  notFound: 'Not found',
  status_count_panel: {
    total: { caption: 'CDs' },
    severity: {
      status: {
        title: 'Condition Evaluation',
        4: 'Very High',
        3: 'High',
        2: 'Medium',
        1: 'Low',
        modec: {
          5: 'Critical Condition',
          4: 'Potential Problem',
          3: 'Alarm Condition',
          2: 'Not Monitored',
          1: 'Not Operated',
          0: 'Normal condition',
        },
      },
    },
    status: {
      total: { title: 'Total', total: 'CDs' },
      action_status: {
        title: 'Action status',
        INVESTIGATING: 'Investigating',
        ACTION_ISSUED: 'Action Issued',
        CANCELED: 'Canceled',
        COMPLETED: 'Completed',
      },
      classification: { title: 'Classification', Useful: 'Useful', 'Not Useful': 'Not Useful' },
    },
  },
  error: {
    noOpenConditionDeviations: 'There are no open condition deviations at the moment.',
    noClosedConditionDeviations: 'There are no closed condition deviations in the selected period.',
    noConditionDeviations: 'There are no condition deviations in the selected period.',
  },
};
